import React from "react";
import "./Projects.css";

export default function Projects() {
  return (
    <section className="projects-page pixel-text">
      <div className="projects-container">
        <h2 className="page-title glitch-text">EPIC QUESTS</h2>
        <p className="page-subtitle text-small">
          Building legendary systems with modern tech
        </p>

        <div className="project-grid">
          <div className="project-card retro-container">
            <div className="project-header">
              <h3>Java Adventure Game</h3>
              <span className="status-badge">LIVE</span>
            </div>

            <p className="project-description text-small">
              Point-and-click adventure game honoring classic titles of yore
              with a modern UI and immersive narration. Built with Java using
              MVC design pattern for clean separation of game logic, view
              rendering, and user interaction. Features rich storytelling,
              inventory system, and puzzle mechanics that capture the spirit of
              adventure gaming's golden age.
            </p>

            <div className="tech-stack">
              <span className="tech-badge">Java</span>
              <span className="tech-badge">MVC Pattern</span>
              <span className="tech-badge">GUI Development</span>
              <span className="tech-badge">Game Design</span>
              <span className="tech-badge">Narrative Systems</span>
            </div>

            <div className="project-links">
              <button
                className="nes-button"
                disabled
                style={{ opacity: 0.5, cursor: "not-allowed" }}
              >
                LIVE DEMO
              </button>
              <a
                href="https://github.com/JeffreyHeytow/hey-quest"
                target="_blank"
                rel="noopener noreferrer"
                className="nes-button"
              >
                VIEW CODE
              </a>
            </div>
          </div>

          <div className="project-card retro-container">
            <div className="project-header">
              <h3>KubeLearn</h3>
              <span className="status-badge">LIVE</span>
            </div>

            <p className="project-description text-small">
              Interactive Kubernetes learning platform powered by Google Gemini
              AI. Features real-time YAML validation, drag-and-drop architecture
              games, and AI-driven personalized hints. Includes Redis-backed
              rate limiting, responsive design, and progressive learning paths
              from pods to advanced deployments.
            </p>

            <div className="tech-stack">
              <span className="tech-badge">React</span>
              <span className="tech-badge">Google Gemini AI</span>
              <span className="tech-badge">Kubernetes</span>
              <span className="tech-badge">Redis</span>
              <span className="tech-badge">@dnd-kit</span>
              <span className="tech-badge">YAML Validation</span>
            </div>

            <div className="project-links">
              <a
                href="https://kubelearn.jeffheytow.com"
                target="_blank"
                rel="noopener noreferrer"
                className="nes-button"
              >
                LIVE DEMO
              </a>
              <a
                href="https://github.com/JeffreyHeytow/kubelearn"
                target="_blank"
                rel="noopener noreferrer"
                className="nes-button"
              >
                VIEW CODE
              </a>
            </div>
          </div>

          <div className="project-card retro-container">
            <div className="project-header">
              <h3>Test Detective</h3>
              <span className="status-badge">LIVE</span>
            </div>

            <p className="project-description text-small">
              Gamified QA training platform with 30+ randomized test scenarios
              covering real-world software testing challenges. Players identify
              bugs, coverage gaps, and test weaknesses under time pressure.
              Integrates Google Gemini AI for context-aware hints and features
              score tracking, difficulty progression, and comprehensive QA
              concept coverage.
            </p>

            <div className="tech-stack">
              <span className="tech-badge">React</span>
              <span className="tech-badge">Google Gemini AI</span>
              <span className="tech-badge">QA Methodology</span>
              <span className="tech-badge">Game Logic</span>
              <span className="tech-badge">State Management</span>
            </div>

            <div className="project-links">
              <a
                href="https://testdetective.jeffheytow.com"
                target="_blank"
                rel="noopener noreferrer"
                className="nes-button"
              >
                PLAY GAME
              </a>
              <a
                href="https://github.com/JeffreyHeytow/testdetective"
                target="_blank"
                rel="noopener noreferrer"
                className="nes-button"
              >
                VIEW CODE
              </a>
            </div>
          </div>

          <div className="project-card retro-container">
            <div className="project-header">
              <h3>OWASP Bounty Hunter</h3>
              <span className="status-badge">LIVE</span>
            </div>

            <p className="project-description text-small">
              Arcade-style shooter teaching OWASP Top 10:2025 vulnerabilities
              through engaging gameplay. Battle vulnerability-themed enemies,
              face boss fights for each security category, and learn defensive
              strategies. Features custom chiptune soundtrack via Web Audio API,
              particle effects, combo multipliers, and educational tooltips for
              real-world security applications.
            </p>

            <div className="tech-stack">
              <span className="tech-badge">React</span>
              <span className="tech-badge">OWASP Top 10:2025</span>
              <span className="tech-badge">Web Audio API</span>
              <span className="tech-badge">Canvas Animation</span>
              <span className="tech-badge">Game Physics</span>
              <span className="tech-badge">Cybersecurity</span>
            </div>

            <div className="project-links">
              <a
                href="https://bountyhunter.jeffheytow.com"
                target="_blank"
                rel="noopener noreferrer"
                className="nes-button"
              >
                PLAY GAME
              </a>
              <a
                href="https://github.com/JeffreyHeytow/bountyhunter"
                target="_blank"
                rel="noopener noreferrer"
                className="nes-button"
              >
                VIEW CODE
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
